export default __webpack_public_path__ + "static/media/portfolio-hover-161.201fd3ec.jpg";